"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _isEmpty2 = _interopRequireDefault(require("lodash/isEmpty"));

var _get2 = _interopRequireDefault(require("lodash/get"));

var _analyticsUtils = require("./analyticsUtils");

var _default = {
  // see https://github.com/segmentio/analytics.js/blob/master/analytics.js
  // Analytics.prototype.track for details
  track: function track(name, properties, options, fn) {
    if (!(0, _get2.default)(typeof window !== 'undefined' ? window : {}, 'analytics', false)) {
      /* eslint no-console:0 */
      console.warn('Analytics not loaded - tracking event not completed');
      return;
    }

    window.analytics.track(name, properties, options, fn);
  },
  enhancedTrack: function enhancedTrack(rules, state) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    if ((0, _get2.default)(typeof window !== 'undefined' ? window : {}, 'analytics', false) && typeof rules !== 'undefined' && !(0, _isEmpty2.default)(rules)) {
      (0, _analyticsUtils.fireEachEvent)(window || {}, rules, callback, state, window.analytics.track);
    }
  },
  enhancedAnalyticsEvent: function enhancedAnalyticsEvent(rules, state) {
    var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    if ((0, _get2.default)(typeof window !== 'undefined' ? window : {}, 'analytics', false) && typeof rules !== 'undefined' && !(0, _isEmpty2.default)(rules)) {
      if (Array.isArray(rules)) {
        // If rules is an array then split the array into page and track events
        (0, _analyticsUtils.fireEachEvent)(window || {}, rules.filter(function (rule) {
          return rule.type === 'page';
        }), callback, state, window.analytics.page);
        (0, _analyticsUtils.fireEachEvent)(window || {}, rules.filter(function (rule) {
          return rule.type !== 'page';
        }), callback, state, window.analytics.track);
      } else if (rules.type === 'page') {
        (0, _analyticsUtils.fireEachEvent)(window || {}, rules, callback, state, window.analytics.page);
      } else {
        (0, _analyticsUtils.fireEachEvent)(window || {}, rules, callback, state, window.analytics.track);
      }
    }
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/analytics/tracker.js
// module id = 1191
// module chunks = 25